import { render, staticRenderFns } from "./StaffVisaDocuments.vue?vue&type=template&id=755d47fe&"
import script from "./StaffVisaDocuments.vue?vue&type=script&lang=js&"
export * from "./StaffVisaDocuments.vue?vue&type=script&lang=js&"
import style0 from "./StaffVisaDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports